import React from 'react';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';

const FontSelector = ({ selectedFont, setSelectedFont }) => {
  return (
    <div style={{ marginBottom: '15px' }}>
      <Typography
        variant="h6"
        style={{ fontWeight: 'bold', marginBottom: '15px' }}
      >
        Tipografía de la encuesta:
      </Typography>
      
      <FormControl fullWidth size="small">
        <InputLabel id="font-family-label">
          Tipo de letra para la encuesta
        </InputLabel>
        <Select
          labelId="font-family-label"
          id="font-family-select"
          value={selectedFont}
          label="Tipo de letra para la encuesta"
          onChange={(e) => setSelectedFont(e.target.value)}
        >
          <MenuItem value="Roboto" style={{ fontFamily: 'Roboto' }}>
            Roboto (Por defecto)
          </MenuItem>
          <MenuItem value="Arial" style={{ fontFamily: 'Arial' }}>
            Arial
          </MenuItem>
          <MenuItem value="Helvetica" style={{ fontFamily: 'Helvetica' }}>
            Helvetica
          </MenuItem>
          <MenuItem value="Times New Roman" style={{ fontFamily: 'Times New Roman' }}>
            Times New Roman
          </MenuItem>
          <MenuItem value="Georgia" style={{ fontFamily: 'Georgia' }}>
            Georgia
          </MenuItem>
          <MenuItem value="Verdana" style={{ fontFamily: 'Verdana' }}>
            Verdana
          </MenuItem>
          <MenuItem value="Courier New" style={{ fontFamily: 'Courier New' }}>
            Courier New
          </MenuItem>
          <MenuItem value="Comic Sans MS" style={{ fontFamily: 'Comic Sans MS' }}>
            Comic Sans MS
          </MenuItem>
          <MenuItem
            value="Century Gothic"
            style={{ fontFamily: '"Century Gothic", Arial, sans-serif' }}
          >
            Century Gothic
          </MenuItem>
        </Select>
        <FormHelperText>
          Seleccione el tipo de letra que se utilizará en toda la encuesta
        </FormHelperText>
      </FormControl>
    </div>
  );
};

export default FontSelector;